module.exports = __webpack_public_path__ + "img/noProfileImage.0a528fb3.png";